module.exports = __webpack_public_path__ + "img/05e_Buy_Scene.a92f6392.jpg";